import axios, { AxiosResponse } from "axios";
import { config } from "../config/envConfig";
import { refreshAccess } from "../utils/cookies";
import {
  EnterpriseSolutionsAxiosResponse,
  EnterpriseSolutionsResponse,
} from "src/models/EnterpriseSolutionsResponse";

const { enterpriseSolutionsUrl } = config.environment;

export const enterpriseSolutionsService = async (
  userId: number,
  isDeviceEnabled?: boolean
): Promise<EnterpriseSolutionsAxiosResponse> => {
  const instance = axios.create({
    baseURL: enterpriseSolutionsUrl,
    timeout: 30000,
  });

  const cookie = await refreshAccess(isDeviceEnabled);

  try {
    const response: AxiosResponse<EnterpriseSolutionsResponse> =
      await instance.get(`/${userId}/role`, {
        headers: {
          Authorization: `Bearer ${cookie}`,
          accept: "application/json",
        },
      });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    console.log("Error retrieving enterprise solutions user role:", error);
    return {
      status: 500,
      data: { isAdminUser: false },
    };
  }
};
